@if (currentToast()) {
  <div class="position-fixed p-3 mw-100" style="width: 350px; right: 0; z-index: 99999">
    <mwe-inline-notification
      [type]="currentToast().type"
      [showCloseButton]="currentToast().isClosable"
      [titleKey]="currentToast().title"
      [messageKey]="currentToast().message"
    />
  </div>
}
